'use strict';

module.exports = Object.assign(function () {
    for (var _len = arguments.length, xs = Array(_len), _key = 0; _key < _len; _key++) {
        xs[_key] = arguments[_key];
    }

    console.log.apply(console, xs);
    return xs[xs.length - 1];
}, {
    id: function id() {
        var _ref;

        return _ref = arguments.length - 1, arguments.length <= _ref ? undefined : arguments[_ref];
    },
    l: console.log,
    hola: function hola() {
        return console.log('hola');
    },
    start: function start() {
        return console.log('\n.\n..\n...\n....\n.....\n......\n.......\n........\nStarting:....\n');
    },
    end: function end() {
        return console.log('\nEnding:....\n........\n.......\n......\n.....\n....\n...\n..\n.\n');
    },
    c: function c(msg) {
        return function (x) {
            //curried
            console.log(msg, x);
            return x;
        };
    },
    ap: function ap(fn, x) {
        console.log(fn(x), x);
        return x;
    },
    ap_c: function ap_c(fn) {
        return function (x) {
            console.log(fn(x), x);
            return x;
        };
    },
    ap_m: function ap_m(msg, fn, x) {
        //with message
        console.log(msg, fn(x), x);
        return x;
    },
    ap_c_m: function ap_c_m(msg, fn) {
        return function (x) {
            //with message
            console.log(msg, fn(x), x);
            return x;
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/tap-logger/lib/index.js
// module id = ./node_modules/tap-logger/lib/index.js
// module chunks = 0 1